"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionId = exports.getHttpRequestId = void 0;
const uuid_1 = require("uuid");
const universal_cookie_1 = __importDefault(require("universal-cookie"));
const COOKIE_SESSION_ID = 'session-id';
const EMPTY_SESSION_VALUE = '';
const cookies = new universal_cookie_1.default();
const instance = {
    httpRequestId: undefined,
    sessionId: undefined,
};
exports.getHttpRequestId = () => {
    if (!instance.httpRequestId) {
        instance.httpRequestId = uuid_1.v4();
    }
    return instance.httpRequestId;
};
exports.getSessionId = () => {
    var _a;
    if (!instance.sessionId) {
        instance.sessionId = (_a = cookies.get(COOKIE_SESSION_ID)) !== null && _a !== void 0 ? _a : EMPTY_SESSION_VALUE;
    }
    return instance.sessionId;
};
